import { cn } from '@mntn-dev/ui-utilities'
import type { PropsWithChildren } from 'react'
import type { TestIds } from '../../../../utils/testing.ts'
import { Text, type TextProps } from '../../../text/text.tsx'
import { type CardScale, useCardContext } from '../../use-card.ts'

const fontSizeMap: Record<CardScale, TextProps['fontSize']> = {
  sm: 'sm',
  md: 'base',
  lg: 'lg',
}

export type CardHeadingCompactTitleProps = PropsWithChildren<
  {
    className?: string
  } & TestIds
>

export const CardHeadingCompactTitle = ({
  children,
  className,
  ...testIds
}: CardHeadingCompactTitleProps) => {
  const { scale } = useCardContext()

  return (
    <Text
      fontSize={scale ? fontSizeMap[scale] : 'lg'}
      className={cn('line-clamp-1 truncate', className)}
      {...testIds}
    >
      {children}
    </Text>
  )
}
